/**
 * PanelTitle Component - 패널(탭 안) 제목 + (i) 설명 툴팁
 * - Topbar 의 description 과 같은 방식: 설명은 제목 아래가 아니라 (i) 아이콘 툴팁으로
 *   <PanelTitle title="메뉴 관리" description="사이드바 메뉴 항목과 …" />
 */

import { Tooltip } from '../ui';
import InfoIcon from '../../assets/icons/common/info.svg?react';

interface PanelTitleProps {
  title: React.ReactNode;
  description?: React.ReactNode;
}

export function PanelTitle({ title, description }: PanelTitleProps) {
  return (
    <div className="topbar-heading">
      <h2 className="admin-panel-title">{title}</h2>
      {description && (
        <Tooltip content={description} placement="right">
          <button type="button" className="topbar-info panel-info" aria-label="설명">
            <InfoIcon />
          </button>
        </Tooltip>
      )}
    </div>
  );
}

export default PanelTitle;
